let initialState = {
  voucher: null
}

export default {
  state: () => initialState,
  mutations: {
    SET_VOUCHER(state, voucher) {
      state.voucher = voucher
    },
    RESET_VOUCHER(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    RESET(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {
    setVoucher({ commit }, voucher) {
      commit('SET_VOUCHER', voucher)
    },
    resetVoucher({ commit }, voucher) {
      commit('RESET_VOUCHER', voucher)
    }
  },
  getters: {
    voucher: state => {
      return state.voucher
    }
  }
}
